/* ============================================================
   custom-header.js
   Handles:
   1. Mobile hamburger — opens / closes the nav drawer
   2. Mobile accordion — expands dropdown children inside the drawer
   3. Top-left image dropdown — click toggle + outside-click close
   ============================================================ */

(function () {
  'use strict';

  // ── 1. Mobile hamburger ───────────────────────────────────
  document.querySelectorAll('.custom-header__toggle').forEach(function (toggle) {
  var header    = toggle.closest('.custom-header');
  var mobileNav = header && header.querySelector('.custom-header__nav--mobile');

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    var next   = !isOpen;

    if (next && header) {
      const bottom = Math.round(header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(
        '--mobile-header-h',
        bottom + 'px'
      );
    }

    toggle.setAttribute('aria-expanded', String(next));

    if (header) {
      header.setAttribute('data-open', String(next));
    }

    if (mobileNav) {
        mobileNav.setAttribute('aria-hidden', String(!next));
      }

      /* Reset all open submenus when closing mobile nav */
      if (!next && mobileNav) {
        mobileNav
          .querySelectorAll('.custom-header__menu-link--parent')
          .forEach(function (btn) {
            btn.setAttribute('aria-expanded', 'false');

            var submenu = document.getElementById(
              btn.getAttribute('aria-controls')
            );

            if (submenu) {
              submenu.classList.remove('is-open');
              submenu.setAttribute('aria-hidden', 'true');
            }
          });
      }
  });
});
  

  function setMobileHeaderHeight() {
  var header = document.querySelector('.custom-header');
  if (!header) return;
  var mobileBar = header.querySelector('.custom-header__top--mobile');
  var bar = mobileBar || header;
  var h = bar.getBoundingClientRect().height || bar.offsetHeight;
  // Only add announce height if bar is still visible (not scrolled away)
  var announce = document.querySelector('.announcement-bar');
  var aH = (announce && !document.body.classList.contains('scrolled'))
    ? announce.offsetHeight
    : 0;
  document.documentElement.style.setProperty('--mobile-header-h', (h + aH) + 'px');
}

setMobileHeaderHeight();

  // ── 2. Mobile accordion dropdowns ────────────────────────
  // Each parent button inside the mobile nav expands its sibling <ul>
  document.querySelectorAll('.custom-header__menu-link--parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen   = btn.getAttribute('aria-expanded') === 'true';
      var submenu  = document.getElementById(btn.getAttribute('aria-controls'));

      // Close all other open submenus first (accordion behaviour)
      document.querySelectorAll('.custom-header__menu-link--parent[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var otherMenu = document.getElementById(other.getAttribute('aria-controls'));
          if (otherMenu) otherMenu.classList.remove('is-open');
        }
      });

      btn.setAttribute('aria-expanded', String(!isOpen));
      if (submenu) submenu.classList.toggle('is-open', !isOpen);
    });
  });

  // ── 3. Top-left image dropdown ────────────────────────────
  document.querySelectorAll('.custom-header__image-trigger').forEach(function (trigger) {
    var dropdown = trigger.closest('.custom-header__image-dropdown');
    var menu     = dropdown && dropdown.querySelector('.custom-header__image-dropdown-menu');

    if (!menu) return;

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      menu.classList.toggle('is-open', !isOpen);
    });
  });

  // Close image dropdown on outside click
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.custom-header__image-dropdown').forEach(function (dropdown) {
      if (!dropdown.contains(e.target)) {
        var trigger = dropdown.querySelector('.custom-header__image-trigger');
        var menu    = dropdown.querySelector('.custom-header__image-dropdown-menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu)    menu.classList.remove('is-open');
      }
    });
  });

  // Close image dropdown on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.custom-header__image-dropdown').forEach(function (dropdown) {
      var trigger = dropdown.querySelector('.custom-header__image-trigger');
      var menu    = dropdown.querySelector('.custom-header__image-dropdown-menu');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu)    menu.classList.remove('is-open');
    });
  });

})();

/* Set --mobile-header-h so the drawer starts exactly below the header */

// window.addEventListener('resize', setMobileHeaderHeight);
(function () {
  var announceBar = document.querySelector('.announcement-bar');
  var header = document.querySelector('.custom-header--sticky');

  function setAnnounceHeight() {
    if (!announceBar) return;
    var h = announceBar.offsetHeight;
    document.documentElement.style.setProperty('--announce-h', h + 'px');
  }

  function onScroll() {
    if (window.scrollY > 10) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }

  setAnnounceHeight();
  onScroll(); // run once on load in case page loads scrolled

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setAnnounceHeight);
})();